import { UsersActionTypes } from './constants';
import { PAGINATION_DEFAULT_VALUE } from '../../helpers/defaultValue';

const INIT_STATE = {
    loading: false,
    error: null,
    users: null,
    pagination: PAGINATION_DEFAULT_VALUE,
};

type UsersAction = {
    type: string,
    payload: { actionType?: string, data?: any, error?: string },
};

//TODO: define data type for users
type State = { loading: Boolean, error?: null, users: any };

const Users = (state: State = INIT_STATE, action: UsersAction): any => {
    //console.log(action);
    switch (action.type) {
        case UsersActionTypes.API_RESPONSE_SUCCESS:
            switch (action.payload.actionType) {
                case UsersActionTypes.GET_ALL_USERS: {
                    return { 
                        ...state, 
                        loading: false, 
                        users: action.payload.data.users,
                        pagination: { ...PAGINATION_DEFAULT_VALUE, ...action.payload.data.pagination },
                    };
                }
                default:
                    return { ...state, loading: false };
            }

        case UsersActionTypes.API_RESPONSE_ERROR:
            switch (action.payload.actionType) {
                default:
                    return { ...state, loading: false };
            }
        case UsersActionTypes.GET_ALL_USERS:
            return { ...state, loading: true, users: null };
        case UsersActionTypes.RESET_ALL_ERRORS:
            return { ...state, error: null };
        default:
            return { ...state };
    }
};

export default Users;
